import { render, staticRenderFns } from "./navButton.vue?vue&type=template&id=743560f4&scoped=true&"
import script from "./navButton.vue?vue&type=script&lang=js&"
export * from "./navButton.vue?vue&type=script&lang=js&"
import style0 from "./navButton.vue?vue&type=style&index=0&id=743560f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743560f4",
  null
  
)

export default component.exports